import { apiRequest } from "../util/apiUtils";

export const bookAdd = async (payload) => {
  try {
    const res = await apiRequest("post", `book/add`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const booksGet = async () => {
  try {
    const res = await apiRequest("get", `book/list`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const bookEdit = async (params) => {
  try {
    const res = await apiRequest("put", `book/edit`, {
      body: params
    })
    return res?.data
  } catch (err) {
    throw err
  }
}

export const reorderBooks = async (params) => {
  try {
    await apiRequest("patch", `media/ordering`, {
      body: params
    })
  } catch (err) {
    throw err
  }
}

export const removeBookImage = async (id) => {
  try {
    await apiRequest("delete", `media/delete/${id}`);
  } catch (err) {
    throw err;
  }
}
